{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Vælg et element",
  "tableResizer": "Størrelsesændring",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
